import cn from 'classnames';
import Link from 'next/link';
import { REGISTRATION_PATHNAME } from '@/shared/constants/pathnames';
import { Text } from '@/shared/ui/core';
import { HaveNoAccountProps } from '../model/have-no-account.props';
import styles from './have-no-account.module.scss';


export const HaveNoAccount = ({ className, href = REGISTRATION_PATHNAME }: HaveNoAccountProps) => {
    return (
        <Text
            size='lg'
            tone='secondary'
            className={ cn(styles.root, className) }
        >
            Don&apos;t have an account yet?{ ' ' }
            <Link href={ href }>
                <Text
                    as='span'
                    size='lg'
                    weight='semibold'
                    tone='primary'
                    className={ styles.sign_up }
                >
                    Sign up
                </Text>
            </Link>
        </Text>
    );
};
